<template>
  <PaymentCompleted v-if="session" payment-id="" :payment-success-redirect="true" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import PaymentCompleted from "@/components/PaymentCompleted.vue";
import { ISession } from "@/types/ISession";
import authHelper from "@/helpers/authHelper";

export default defineComponent({
  name: "PaymentSuccessView",
  components: { PaymentCompleted },
  setup() {
    const { t } = useI18n();
    const session: ISession | null = authHelper.getSession();

    return {
      t,
      session
    };
  },
  beforeMount() {
    if(!this.session) {
      window.open("https://payjoy.com", "_self");
    }
  }
});
</script>
